import { useStore } from 'effector-react';
import Slider from '@components/Slider';
import { $compareState, $compareStateApi } from '../compareStores';
import { AlphaSliderBar } from './AlphaSliderBar';

export function ModeOverlapWidgets() {
  const { alpha } = useStore($compareState);
  return (
    <div className="absolute bottom-70 w-300 rounded-[10px] bg-black-black/50 px-20 py-10">
      <Slider
        value={alpha}
        min={0}
        max={1}
        onChange={(x) => {
          $compareStateApi.setAlpha(x);
        }}
      >
        <AlphaSliderBar step={0.01} />
      </Slider>
    </div>
  );
}
